import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {fetchSourceCategories} from '~/modules/Clients/api';

type ISelectCategoryProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectSourceCategory = ({
    disabled,
    ...props
}: ISelectCategoryProps) => {
    const {resource, isPending} = useResource(() => fetchSourceCategories(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && !disabled && <i className='fa fa-spinner fa-spin'/>}
        items={resource}/>;
};

export const SelectSourceCategoryField = (props: IFieldProps<ISelectCategoryProps>) => <FormField {...props}>
    <SelectSourceCategory {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
